import Backbone from 'backbone';

export default Backbone.View.extend({
	events: {
		'change [name=digital-report-archive]': 'redirect'
	},

	initialize: function() {
		this.activeYear = $('#digital-report-archive-year').val();
		this.activeMonth = $('#digital-report-archive-month').val();
	},

	render: function() {
		return this;
	},

	redirect: function() {
		var year = $('#digital-report-archive-year').val(),
			month = $('#digital-report-archive-month').val();

		if (year !== this.activeYear || month !== this.activeMonth) {
			document.location = '/bx-digital/report-archive/' + year + '/' + month;
		}
	}
});
